"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var data_service_1 = require("./data.service");
function getPrimaryChildType(element) {
    var childrenTypes = element.XO_service.getChildrenType();
    if (childrenTypes.length == 0) {
        return null;
    }
    return childrenTypes[0];
}
exports.getPrimaryChildType = getPrimaryChildType;
function getSecondaryChildType(element) {
    var childrenTypes = element.XO_service.getChildrenType();
    if (childrenTypes.length < 1) {
        return null;
    }
    return childrenTypes[1];
}
exports.getSecondaryChildType = getSecondaryChildType;
var ElementService = /** @class */ (function (_super) {
    tslib_1.__extends(ElementService, _super);
    function ElementService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ElementService.prototype.save = function (object, exists) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent, savedObject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parent = object.XO_parent;
                        return [4 /*yield*/, _super.prototype.save.call(this, object, exists)];
                    case 1:
                        savedObject = _a.sent();
                        savedObject.XO_parent = parent;
                        return [2 /*return*/, savedObject];
                }
            });
        });
    };
    return ElementService;
}(data_service_1.DataService));
exports.ElementService = ElementService;
//# sourceMappingURL=element.service.js.map